import React from 'react';
import cx from 'classnames'
import { FormattedMessage } from 'react-intl';
import styles from 'pages/pages.module.css'
import pricingStyles from 'pages/pricing/pricing.module.css'

const Discounts = () => (
    <section className={cx(styles.content, pricingStyles.discounts)}>
        <div className={styles.wrapper}>
            <h2 id="discounts"><FormattedMessage id="Discounts.title" defaultMessage="Discounts" /></h2>
            <h4><FormattedMessage id="Discounts.caption" defaultMessage="We provide flexible discounts for our customers" /></h4>
            <div className={pricingStyles.list}>
                <div className={pricingStyles.row}>
                    <div className={pricingStyles.count}>
                        50+ <FormattedMessage id="Discounts.workers" defaultMessage="workers" />
                    </div>
                    <div className={pricingStyles.discount}>
                        10%
                    </div>
                </div>
                <div className={pricingStyles.row}>
                    <div className={pricingStyles.count}>
                        100+
                    </div>
                    <div className={pricingStyles.discount}>
                        20%
                    </div>
                </div>
                <div className={pricingStyles.row}>
                    <div className={pricingStyles.count}>
                        250+
                    </div>
                    <div className={pricingStyles.discount}>
                        30%
                    </div>
                </div>
                <div className={pricingStyles.row}>
                    <div className={pricingStyles.count}>
                        500+
                    </div>
                    <div className={pricingStyles.discount}>
                        40%
                    </div>
                </div>
                <div className={pricingStyles.row}>
                    <div className={pricingStyles.count}>
                        1000+
                    </div>
                    <div className={pricingStyles.discount}>
                        50%
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Discounts;